module.exports = __webpack_public_path__ + "522caa4a2d23364282bc9b591f1113cc.MP3";